// Table Diff / Row-Count Comparison API client (admin). Compares per-table row
// counts + sizes between two databases (same or cross-connection).
import { api } from './api.js';

// mode: 'estimate' (information_schema, instant) | 'exact' (COUNT(*) per table).
// → { rows: [{name, a?:{rows,size,avgRow}, b?:{…}, rowsDelta, sizeDelta, status}],
//     summary: { same, diff, onlyA, onlyB, tables }, mode }
export const compareTables = (connA, dbA, connB, dbB, mode = 'estimate') =>
  api.post('/api/tools/table-compare', { connA: Number(connA), dbA, connB: Number(connB), dbB, mode });
